import classNames from "classnames";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./clickable-icon.less";

type ClickableIconProps = {
    className: string;
    onClick: () => void;
    icon: IconDefinition;
    disabled?: boolean;
    controlId: string;
};

export const ClickableIcon = (props: ClickableIconProps) => {
    const { className, onClick, icon, disabled, controlId } = props;

    const handleOnClick = () => {
        if (!disabled) {
            onClick();
        }
    }

    return (
        <FontAwesomeIcon
            id={`${controlId}-clickable-icon`}
            className={classNames(className, disabled ? styles.disabled : "")}
            onClick={handleOnClick}
            icon={icon}
        />
    );
};